'use client';
import { Clock, Moon, Sun } from 'lucide-react';
import { useEffect, useState } from 'react';
import {
  aplicarTema,
  guardarPreferencia,
  leerPreferencia,
  type Preferencia,
  vigilarTema,
} from './tema';

const OPCIONES: { valor: Preferencia; texto: string; Icono: typeof Sun }[] = [
  { valor: 'claro', texto: 'Claro', Icono: Sun },
  { valor: 'oscuro', texto: 'Oscuro', Icono: Moon },
  { valor: 'auto', texto: 'Automático (oscuro de 19:00 a 7:00)', Icono: Clock },
];

/** Selector Claro · Oscuro · Automático; siempre a la mano en la barra de cada frente. */
export function SelectorTema({ className }: { className?: string }) {
  const [preferencia, setPreferencia] = useState<Preferencia>('auto');
  useEffect(() => {
    setPreferencia(leerPreferencia());
    return vigilarTema((_t, p) => setPreferencia(p));
  }, []);
  const elegir = (p: Preferencia) => {
    guardarPreferencia(p);
    aplicarTema(p);
    setPreferencia(p);
  };
  return (
    <div
      className={`ui-selector-tema${className ? ` ${className}` : ''}`}
      role="group"
      aria-label="Tema de la pantalla"
    >
      {OPCIONES.map(({ valor, texto, Icono }) => (
        <button
          key={valor}
          type="button"
          aria-pressed={preferencia === valor}
          aria-label={texto}
          title={texto}
          onClick={() => elegir(valor)}
        >
          <Icono size={16} strokeWidth={1.75} aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}
